// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partials_invoiceBody__e\\+Oh1 {
  max-width: 500px;
  font-family: Inter;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 450px;
  margin: auto;
}
@media screen and (max-width: 576px) {
  .partials_invoiceBody__e\\+Oh1 {
    min-width: 350px;
  }
}

.partials_invoiceHeader__yQiq2 {
  width: 100%;
  height: 72px;
  padding: 20px 24px 20px 24px;
  background: #F2F3FC;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px 20px 0px 0px;
}

.partials_invoiceMiddle__bjJE6 {
  background: #F2F3FC;
  padding: 0px 24px 0px 24px;
  display: flex;
  flex-direction: column;
}
.partials_invoiceMiddle__bjJE6 .partials_invoiceMiddleItem__w\\+W-M {
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.partials_invoiceFooter__DswoC {
  width: 100%;
  height: 60px;
  padding: 20px 24px 20px 24px;
  background: #F2F3FC;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0px 0px 20px 20px;
}

.partials_blueScreen__mgvwz {
  background-color: #76D1FD;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: relative;
  font-family: Inter;
  text-align: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
}
.partials_blueScreen__mgvwz .partials_logo__KMOg9 {
  position: absolute;
  bottom: 30px;
  left: calc(50% - 96px);
}
.partials_blueScreen__mgvwz .partials_blueScreenContent__78-Zp {
  max-width: 480px;
  height: auto;
  padding: 50px 40px;
  gap: 20px;
  border-radius: 20px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.partials_blueScreen__mgvwz .partials_blueScreenContent__78-Zp p {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Partials/partials.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,gBAAA;EACA,YAAA;AAAJ;AAEI;EAVJ;IAWQ,gBAAA;EACN;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAGI;EAEI,YAAA;EAGA,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AALR;;AAWA;EAEI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AATJ;;AAaA;EACI,yBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAVJ;AAcI;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;AAZR;AAgBI;EACI,gBAAA;EAEA,YAAA;EAGA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAjBR;AAmBQ;EACI,aAAA;AAjBZ","sourcesContent":[".invoiceBody {\n    max-width: 500px;\n    font-family: Inter;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    // width: 50%;\n    min-width: 450px;\n    margin: auto;\n\n    @media screen and (max-width:576px) {\n        min-width: 350px;\n\n    }\n}\n\n.invoiceHeader {\n    width: 100%;\n    height: 72px;\n    padding: 20px 24px 20px 24px;\n    background: #F2F3FC;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 20px 20px 0px 0px;\n}\n\n.invoiceMiddle {\n    background: #F2F3FC;\n    padding: 0px 24px 0px 24px;\n    display: flex;\n    flex-direction: column;\n    // gap: 15px;\n\n    .invoiceMiddleItem {\n        // width: 488px;\n        height: 48px;\n        // padding: var(--spacingspacing-xs-max) var(--spacingspacing-none) var(--spacingspacing-xs-max) var(--spacingspacing-none);\n\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        //styleName: material-theme/body/large;\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        text-align: left;\n\n    }\n\n}\n\n.invoiceFooter {\n\n    width: 100%;\n    height: 60px;\n    padding: 20px 24px 20px 24px;\n    background: #F2F3FC;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 0px 0px 20px 20px;\n}\n\n\n.blueScreen {\n    background-color: #76D1FD;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100vw;\n    position: relative;\n    font-family: Inter;\n    text-align: center;\n    position: fixed;\n    z-index: 100;\n    top: 0;\n    left: 0;\n\n\n\n    .logo {\n        position: absolute;\n        bottom: 30px;\n        left: calc(50% - 96px);\n\n    }\n\n    .blueScreenContent {\n        max-width: 480px;\n        // min-width: 400px;\n        height: auto;\n        // top: 304.29px;\n        // left: 480px;\n        padding: 50px 40px;\n        gap: 20px;\n        border-radius: 20px;\n        background-color: white;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n\n        p {\n            display: none;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoiceBody": `partials_invoiceBody__e+Oh1`,
	"invoiceHeader": `partials_invoiceHeader__yQiq2`,
	"invoiceMiddle": `partials_invoiceMiddle__bjJE6`,
	"invoiceMiddleItem": `partials_invoiceMiddleItem__w+W-M`,
	"invoiceFooter": `partials_invoiceFooter__DswoC`,
	"blueScreen": `partials_blueScreen__mgvwz`,
	"logo": `partials_logo__KMOg9`,
	"blueScreenContent": `partials_blueScreenContent__78-Zp`
};
export default ___CSS_LOADER_EXPORT___;
